import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
export function compose() {
    var validators = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        validators[_i] = arguments[_i];
    }
    return function composedValidator(value) {
        for (var _i = 0, validators_1 = validators; _i < validators_1.length; _i++) {
            var validator = validators_1[_i];
            var error = validator(value);
            if (error) {
                return error;
            }
        }
        return undefined;
    };
}
export function required(message) {
    return function requiredValidator(value) {
        if (!value) {
            return message;
        }
        return undefined;
    };
}
export function zipCode(message) {
    return function zipCodeValidator(value) {
        if (typeof value !== 'string' || !value.match(/^[0-9]{4}$/)) {
            return message;
        }
        return undefined;
    };
}
export function numeric(message) {
    return function numericValidator(value) {
        if (value == null) {
            return;
        }
        if (typeof value !== 'string' || !value.match(/^[0-9]*$/)) {
            return message;
        }
        return undefined;
    };
}
export function date(message, _a) {
    var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, minDate = _b.minDate;
    return function validityDate(value) {
        if (value == null) {
            return undefined;
        }
        var dat = dayjs(value, [
            'YYYY-MM-DD',
            'DD.MM.YYYY',
            'D.MM.YYYY',
            'DD.M.YYYY',
            'D.M.YYYY',
        ], true);
        if (!dat.isValid()) {
            return message;
        }
        if (maxDate && maxDate.isBefore(dayjs(dat))) {
            return message;
        }
        if (minDate && minDate.isAfter(dayjs(dat))) {
            return message;
        }
        return undefined;
    };
}
//# sourceMappingURL=validators.js.map